<template></template>

<script>
export default {
  data: function () {
    return {
      token: this.$route.query.token ? this.$route.query.token : "",
      position: this.$route.query.position ? this.$route.query.position : ""
    };
  },
  mounted: function () {
    if (this.token) {
      this.$store.commit("saveToken", this.token);
      this.$router.push("/");
    } else {
      this.$router.push("/Register?position=" + this.position);
    }
  },
  methods: {},
};
</script>


// WEBPACK FOOTER //
// src/pages/account/AuthLogin.vue